const WHITE_LIST = ['https://api.amplitude.com/', 'https://cdn.growthbook.io/'];
export const monitorNetwork = (callback: (response: { url: string | URL; status: number; response: any }) => void) => {
  // eslint-disable-next-line no-global-assign
  XMLHttpRequest = new Proxy(XMLHttpRequest, {
    construct: function (target, args) {
      // @ts-ignore
      const xhr = new target(...args);
      xhr.onload = function () {
        if (WHITE_LIST.some((url) => xhr.responseURL.includes(url))) {
          callback({
            url: xhr.responseURL,
            status: xhr.status,
            response: xhr.response,
          });
        }
      };
      return xhr;
    },
  });

  // todo-@elie: fetch is not working
  window.fetch = new Proxy(window.fetch, {
    apply: function (target, thisArg, args) {
      // console.log('### fetch', args);
      // @ts-ignore
      const req = target.apply(thisArg, args);
      req.then((res) => {
        // console.log('### fetch res', res);
        if (WHITE_LIST.some((url) => res.url.includes(url))) {
          callback({
            url: res.url,
            status: res.status,
            response: res,
          });
        }
      });
      return req;
    },
  });
};
